module.exports = __webpack_public_path__ + "img/luxury_middle@2x.95fe9a22.png";